import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema, UseFormReturn } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import type { TFunction } from "i18next";

/*
 *  License User Services
 * !== 면허 사용자 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/lcneusr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/lcne-usr`,
    nodes: [],
};

export const URLS = {
    ptli0906001q: `${BASE.path}/ptli0906001q`, // License User List !==  면허 사용자 목록 ==!
    ptli0906002s: `${BASE.path}/ptli0906002s`, // License User Registration !==  면허 사용자 등록 ==!
    ptli0906003s: `${BASE.path}/ptli0906003s`, // Modifying and deleting License User !==  면허 사용자 수정 ==!
    ptli0906004q: `${BASE.path}/ptli0906004q`, // License User Details !==  면허 사용자 상세 ==!
};

export const APIS = {
    // Check License Usr List !==  면허 사용자 목록 조회 ==!
    getLcneUsrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // License User details inquiry !== 면허 사용자 상세 정보 조회 ==!
    getLcneUsrInfo: (lcneCoAplyId: any) => {
        return api.get(`${BASE.api}/${lcneCoAplyId}`);
    },
    // Create License User !== 면허 사용자 생성 ==!
    createLcneUsr: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update License User !==  면허 사용자 수정 ==!
    updateLcneUsr: (data: any) => {
        return api.put(`${BASE.api}/${data.lcneCoAplyId}`, {
            ...data,
        });
    },
    // Delete License User !== 면허 사용자 정보 삭제 ==!
    deleteLcneUsr: (lcneCoAplyId: any) => {
        return api.delete(`${BASE.api}/${lcneCoAplyId}`);
    },
    // TIN Number Search !== TIN 번호 조회 ==!
    getPayerTinNoLst: (tinNo: any, bizYn: any) => {
        return comnUtils.getCode({
            area: "payerTinNo",
            keyword: tinNo,
            param2: bizYn,
        });
    },

    // Reset the License User password. !== 라이센스 사용자 비밀번호를 초기화한다. ==!
    updateLcneUsrPwdInit: (data: any) => {
        return api.put(`${BASE.api}/pwd-init`, {
            ...data,
        });
    },
        
    // License Company Tin apply check !== 면허 업체 TIN 신청 여부 체크 ==!
    getAplyDuplCheck: (coTin: any) => {
        return api.get(`${BASE.api}/getAplyDuplCheck`, {
            params: comnUtils.toGetParams({ coTin: coTin }),
        });
    },

    // Tin duplicate check  !== TIN 중복 체크 ==!
    getUsrDuplCheck: (coTin: any) => {
        return api.get(`${BASE.api}/getUsrDuplCheck`, {
            params: comnUtils.toGetParams({ coTin: coTin }),
        });
    },

    getCoTinCntyCheck: (coTin: any) => {
        return api.get(`${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co/getCoTinCntyCheck`, {
            params: comnUtils.toGetParams({ coTin: coTin }),
        });
    },

    getLcneUsrExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),

    // Change the company name to the name stored in TAXPAYER. !== 업체명을 TAXPAYER 저장 된 업체명으로 변경한다. ==!
    updateLcneUsrCoNm: (data: any) => {
        return api.put(`${BASE.api}/co-nm`, {
            ...data,
        });
    },

    
    // updateLcneUsrFfaexpmt ==!
    updateLcneUsrFfaexpmt: (data: any) => {
        return api.put(`${BASE.api}/ffaexpmt`, {
            ...data,
        });
    },

    // updateLcneUsrFfaexpmt ==!
    updateLcneUsrFfaexpmtBatch: (data: any) => {
        return api.post(`${BASE.api}/ffaexpmt/batch`, data);
    },
    
    // getLcneUsrFfaexpmtStts ==!
    getLcneUsrFfaexpmtStts: (lcneCoAplyId: any) => {
        return api.get(`${BASE.api}/ffaexpmt/${lcneCoAplyId}`);
    }

};

export const SF_LCNE_USR_SRCH: TFormSchema = {
    id: "form_lcneUsrSrch",
    schema: {
        lcneTpCd: {
            type: "select",
            label: "L_LCNE_TP",
            all: true,
            area: "comnCd",
            comnCd: "LCM0001",
            excludes: ["14"],
        },
        coTin: { type: "text", label: "L_CO_TIN" },
        coNm: { type: "text", label: "L_CO_NM" },
        usrStatCd: { type: "select", label: "L_STTS", all: true, area: "comnCd", comnCd: "PTL0001" },
        lcneUsrOrg: { type: "select", label: "L_LCNE_ORG", all: true, area: "comnCd", comnCd: "COM0085" },
    },
};

export const SG_LCNE_USR_LIST: TGridSchema = {
    id: "grid_lcneUsrList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_LCNE_TP", binding: "lcneTpCdNm", width: 0 }], show: false },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "15%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_RPRS_EML", binding: "rprsEml", width: "*" }] },
        { cells: [{ header: "L_STTS", binding: "usrStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "lcneTpCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        {
            cells: [{ binding: "rprsEml", align: "left" }],
        },
        {
            cells: [{ binding: "usrStatCdNm" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};

export const SF_LCNE_USR_INFO: TFormSchema = {
    id: "form_lcneUsrInfo",
    schema: {
        lcneCoAplyId: { type: "text", label: "L_LCNE_CO_APLY_ID" },
        coTin: { type: "text", label: "L_CO_TIN", required: true },
        coNm: { type: "text", label: "L_CO_NM", required: true },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            // controlSize: 10,
            required: true,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10 },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000 },
        coPwd: {
            type: "password",
            label: "L_CO_PWD",
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "비밀번호는 10자 이상이어야 하며, 대문자, 소문자, 숫자, 특수문자를 포함해야 합니다",
            },
        },
        coPwdCfrm: { type: "password", label: "L_CO_PWD_CFRM" },
        emlAddrValdnYn: {
            type: "select",
            label: "L_EML_ADDR_VALDN_YN",
            required: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        preCoAplyId: { type: "text", label: "L_PRE_LCNE_CO_APLY_ID" },
        aprvId: { type: "text", label: "L_APRV_ID" },
        lcneTpCd: {
            type: "checkbox",
            label: "L_LCNE_TP",
            area: "comnCd",
            comnCd: "LCM0001",
            all: true,
            controlSize: 10,
            rows: 5,
            required: true,
            excludes: ["14"],
        },
        lcneTpCdNm: { type: "text", label: "L_LCNE_TP" },
        lcneCoAplcNm: { type: "text", label: "L_LCNE_CO_APLC_NM", required: true },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        usrStatCd: { type: "select", label: "L_STTS", area: "comnCd", comnCd: "PTL0001", select: false },
        ectYn: {
            type: "radio",
            label: "L_ECT_YN",
            options: [
                { label: "No", value: "N" },
                { label: "Yes", value: "Y" },
            ],
            defaultValue: "N",
        },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                // dclrYn: "Y",
            },
        },
        orgMemb: { type: "text", label: "Organization" },
        membStts: { type: "text", label: "Member Status" },
        lcneUseTpCdArray: {
            type: "array",
            schema: {
                lcneUseTpCd: { type: "text", label: "L_LCNE_TP_CD", edit: false },
                lcneTpCd: { type: "text", label: "L_LCNE_TP_CD", edit: false },
                type: {
                    type: "select",
                    options: [
                        { label: "기본", value: "BASE" },
                        { label: "요청", value: "APPLY" },
                    ],
                    edit: false,
                },
            },
        },
        bizTpCd: { type: "text", label: "L_BIZ_TP_CD" },
        tinTp: { type: "text", label: "L_TIN_TP" },
        taxpayerCoNm: { type: "text", label: "L_CO_NM", required: true },
    },
};

export type LCNE_USE_TP_CD_UTIL_TYPE = {
    lcneUseTpCdTarget: {
        [key: string]: { varNm: string; schema: any };
    };
    isLcneUseTpCdTarget: (params: {
        lcneTpCd: string;
        isNotChecked?: boolean;
        lcneTpCdChekedArr?: string[];
    }) => boolean;
    getLcneUseTpCdVarNm: (lcneTpCd: string) => string;
    getLcneUseTpCdSchema: (lcneTpCd: string) => TFormSchema;
    clearLcneUseTpCdSchema: (form: UseFormReturn) => void;
    initLcneUseTpCdSchema: (params: {
        lcneUseTpCdArray?: (any | string)[];
        form: UseFormReturn;
        lcneTpComnCdList: any[];
        isEditeable?: boolean;
        t: TFunction;
    }) => string[];
    makeLcneUseTpCdDtoArray: (data: UseFormReturn, type: "BASE" | "APPLY") => any[];
};

export const LCNE_USE_TP_CD_UTIL: LCNE_USE_TP_CD_UTIL_TYPE = {
    lcneUseTpCdTarget: {
        "1": { varNm: "lcneUseTpCdCfa", schema: { type: "select", area: "comnCd", comnCd: "LCM0019" } },
    },
    isLcneUseTpCdTarget: ({ lcneTpCd, isNotChecked = false, lcneTpCdChekedArr = [] }) =>
        !!LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget[lcneTpCd]
            ? isNotChecked || (!!lcneTpCdChekedArr && lcneTpCdChekedArr.includes(lcneTpCd))
            : false,
    getLcneUseTpCdVarNm: (lcneTpCd) => LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget[lcneTpCd].varNm,
    getLcneUseTpCdSchema: (lcneTpCd) =>
        LCNE_USE_TP_CD_UTIL.isLcneUseTpCdTarget({ lcneTpCd: lcneTpCd, isNotChecked: true })
            ? LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget[lcneTpCd].schema
            : {},
    clearLcneUseTpCdSchema: (form) => {
        Object.keys(LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget).forEach((lcneTpCd) => {
            delete form.schema[LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget[lcneTpCd].varNm];
        });
    },
    initLcneUseTpCdSchema: ({ lcneUseTpCdArray = [], form, lcneTpComnCdList, isEditeable = false, t }) => {
        LCNE_USE_TP_CD_UTIL.clearLcneUseTpCdSchema(form);

        lcneTpComnCdList?.forEach((lcneTpComnCd: any) => {
            const lcneTpCd = lcneTpComnCd.cdVldVal;
            if (
                !!lcneTpCd &&
                lcneTpCd !== "14" &&
                LCNE_USE_TP_CD_UTIL.isLcneUseTpCdTarget({ lcneTpCd: lcneTpCd, isNotChecked: true })
            ) {
                form.setSchema(LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget[lcneTpCd].varNm, {
                    ...LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget[lcneTpCd].schema,
                    edit: isEditeable,
                    readOnly: !isEditeable,
                    label: t("L_LCNE_TP") + "[" + lcneTpComnCd.cdVldValNm + "]",
                });
                form.setValue(
                    LCNE_USE_TP_CD_UTIL.lcneUseTpCdTarget[lcneTpCd].varNm,
                    lcneUseTpCdArray.find((lcneTpCdObj: any | string) => lcneTpCdObj.lcneTpCd === lcneTpCd)
                        ?.lcneUseTpCd,
                );
            }
        });

        return !lcneUseTpCdArray
            ? []
            : lcneUseTpCdArray.map((lcneTpCdObj: any | string) =>
                lcneTpCdObj.lcneTpCd ? lcneTpCdObj.lcneTpCd : lcneTpCdObj,
            );
    },
    makeLcneUseTpCdDtoArray: (data, type) => {
        const resultArr = data?.getValue("lcneTpCd").map((lcneTpCd: string) => {
            return {
                type: type,
                lcneTpCd: lcneTpCd,
                lcneUseTpCd: LCNE_USE_TP_CD_UTIL.isLcneUseTpCdTarget({ lcneTpCd: lcneTpCd, isNotChecked: true })
                    ? data?.getValue(LCNE_USE_TP_CD_UTIL.getLcneUseTpCdVarNm(lcneTpCd))
                    : null,
            };
        });
        return resultArr ? resultArr : [];
    },
};

export const SG_LCNE_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_lcneUsrExcelList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_LCNE_TP", binding: "lcneTpCdNm", width: 0 }], show: false },
        { cells: [{ header: "L_CO_TIN", binding: "coTin", width: "15%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_RPRS_EML", binding: "rprsEml", width: "*" }] },
        { cells: [{ header: "L_STTS", binding: "usrStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "lcneTpCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        {
            cells: [{ binding: "rprsEml", align: "left" }],
        },
        {
            cells: [{ binding: "usrStatCdNm" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};
